import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { FORM_SUBMIT_NOT_COMMITTED } from './AdditionalFormContext';

export const useFormReset = <T extends Record<string, any>>() => {
  const form = useFormContext<T>();

  const resetForm = useCallback(
    (data: T, submitResult: unknown | Promise<unknown>) => {
      const resetAfterSubmit = (result: unknown) => {
        if (result !== FORM_SUBMIT_NOT_COMMITTED) {
          form.reset(data, resetOpts);
        }
      };

      if (submitResult === FORM_SUBMIT_NOT_COMMITTED) {
        // If the submit result indicates that the form submission was not committed, we do not reset the form.
        return;
      }

      if (submitResult && submitResult instanceof Promise) {
        return (
          submitResult
            .then(resetAfterSubmit)
            // Stop error propagation to avoid unhandled promise rejection
            .catch(() => {})
        );
      }
      resetAfterSubmit(submitResult);
    },
    [form],
  );

  return resetForm;
};

const resetOpts = { keepValues: true };
